var _style, _g, _g2, _g3, _g4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSwf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 170.08 76.58",
    style: {
      enableBackground: "new 0 0 170.08 76.58"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{display:none;}\r\n\t.st1{fill:#004996;}\r\n\t.st2{display:inline;fill:none;stroke:#EC008C;stroke-width:0.2835;stroke-miterlimit:10;}\r\n\t.st3{display:inline;fill:#EC008C;}\r\n\t.st4{display:inline;fill:none;}\r\n\t.st5{display:inline;fill:#FFFFFF;}\r\n\t.st6{font-family:'Prometo-Regular';}\r\n\t.st7{font-size:4px;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Form",
    className: "st0"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Logo"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M8.79,67.86l5.78,8.67H9.89l-4.73-7.26l-1.41,7.26H0l3.32-17.01h3.73l-1.34,6.93l6.78-6.93h4.54L8.79,67.86z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M22.92,70.56h-2.58l-1.17,5.97h-3.73l3.32-17.01h5.9c0.94,0,1.79,0.08,2.54,0.25 c0.76,0.17,1.4,0.43,1.93,0.79c0.53,0.36,0.94,0.82,1.23,1.4c0.29,0.57,0.43,1.26,0.43,2.05c0,0.21-0.01,0.43-0.04,0.66 c-0.02,0.23-0.05,0.47-0.08,0.7c-0.24,1.37-0.72,2.42-1.43,3.15c-0.72,0.73-1.58,1.25-2.6,1.55l2.63,6.45h-4.06L22.92,70.56z  M20.94,67.46h2.58c0.57,0,1.05-0.04,1.44-0.11c0.39-0.07,0.72-0.19,0.98-0.35c0.26-0.16,0.47-0.37,0.61-0.65 c0.14-0.27,0.25-0.61,0.33-1.03c0.03-0.16,0.06-0.31,0.07-0.45c0.02-0.14,0.02-0.28,0.02-0.41c0-0.67-0.21-1.13-0.63-1.37 c-0.42-0.25-1.06-0.37-1.92-0.37h-2.58L20.94,67.46z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M42.04,72.43h-6l-2.17,4.11h-4.01l9.55-17.01h4.32l2.77,17.01h-3.92L42.04,72.43z M37.57,69.35h4.13 l-0.79-6.26L37.57,69.35z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M53.47,65.67l-2.1,10.87h-3.73l3.32-17.01h3.2l5.16,10.92l2.13-10.92h3.68l-3.3,17.01h-3.25L53.47,65.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M75.49,62.85l-2.67,13.69h-3.94l2.67-13.69h-5.59l1.24-3.32h14.52l-1.27,3.32H75.49z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M79.96,76.53l3.32-17.01h12.16l-1.27,3.32h-7.76l-0.65,3.37h7.62l-1.27,3.32h-6.97l-0.74,3.68h8.77 l-1.27,3.32H79.96z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M105.16,76.51c-0.32,0.02-0.61,0.03-0.86,0.04c-0.25,0.01-0.51,0.02-0.75,0.02c-0.25,0.01-0.5,0.01-0.76,0.01 s-0.55,0-0.87,0c-1.29,0-2.37-0.14-3.25-0.42c-0.88-0.28-1.58-0.68-2.11-1.19c-0.53-0.52-0.92-1.14-1.16-1.88 c-0.24-0.73-0.36-1.55-0.36-2.46c0-0.88,0.09-1.83,0.29-2.87c0.3-1.62,0.72-2.97,1.27-4.02c0.54-1.06,1.21-1.91,2.02-2.54 c0.8-0.64,1.73-1.08,2.78-1.34c1.05-0.25,2.24-0.38,3.56-0.38c0.29,0,0.55,0,0.8,0c0.25,0,0.5,0,0.78,0.01 c0.27,0.01,0.58,0.02,0.93,0.02c0.35,0.01,0.77,0.02,1.27,0.04l-1.27,3.32c-0.61-0.03-1.1-0.05-1.48-0.06 c-0.38-0.01-0.8-0.01-1.27-0.01c-0.81,0-1.51,0.08-2.09,0.24c-0.58,0.16-1.08,0.44-1.49,0.84c-0.41,0.4-0.76,0.93-1.04,1.59 c-0.28,0.66-0.52,1.5-0.73,2.52c-0.19,0.96-0.29,1.75-0.29,2.39c0,0.57,0.08,1.04,0.23,1.41c0.15,0.37,0.37,0.66,0.67,0.87 c0.29,0.22,0.66,0.37,1.1,0.45c0.44,0.09,0.94,0.13,1.52,0.13c0.38,0,0.73,0,1.05,0c0.32,0,0.63,0,0.92-0.01 c0.29-0.01,0.59-0.02,0.9-0.02c0.3-0.01,0.63-0.01,0.98-0.01L105.16,76.51z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M119.08,69.61h-6.45l-1.34,6.93h-3.94l3.32-17.01h3.94l-1.29,6.62h6.42l1.29-6.62h3.94l-3.32,17.01h-3.94 L119.08,69.61z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M130.02,65.67l-2.1,10.87h-3.73l3.32-17.01h3.2l5.16,10.92L138,59.53h3.68l-3.3,17.01h-3.25L130.02,65.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M148.17,59.53l-3.32,17.01h-3.94l3.32-17.01H148.17z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M156.17,67.86l5.78,8.67h-4.68l-4.73-7.26l-1.41,7.26h-3.75l3.32-17.01h3.73l-1.34,6.93l6.78-6.93h4.54 L156.17,67.86z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M49.95,12.69l-16.91,0c-2.25,0-3.54,0.55-3.87,1.65c-0.05,0.14-0.08,0.3-0.11,0.47 c-0.02,0.17-0.04,0.37-0.04,0.61c0,0.53,0.22,0.94,0.65,1.25c0.43,0.31,1.1,0.61,2.01,0.9l6.59,2.08 c2.15,0.67,3.94,1.43,5.37,2.29c1.43,0.86,2.58,1.82,3.44,2.87c0.86,1.05,1.48,2.2,1.86,3.44c0.38,1.24,0.57,2.56,0.57,3.94 c0,0.72-0.05,1.45-0.14,2.19c-0.1,0.74-0.22,1.52-0.36,2.33c-0.53,2.58-1.33,4.79-2.4,6.63c-1.08,1.84-2.56,3.34-4.44,4.51 c-1.89,1.17-4.23,2.02-7.02,2.54c-2.79,0.53-6.15,0.65-10.07,0.65H5.67l4.82-12.69l17.04,0c1.81,0,3.08-0.15,3.8-0.47 c0.72-0.31,1.17-0.94,1.36-1.9c0.05-0.19,0.07-0.43,0.07-0.72c0-0.62-0.23-1.1-0.68-1.43c-0.45-0.33-1.09-0.62-1.9-0.86 l-6.31-1.93c-2.25-0.67-4.11-1.42-5.59-2.26c-1.48-0.83-2.66-1.77-3.55-2.79c-0.88-1.03-1.52-2.14-1.9-3.33 c-0.38-1.19-0.57-2.48-0.57-3.87c0-1.29,0.14-2.7,0.43-4.23c0.52-2.96,1.49-5.4,2.9-7.31c1.41-1.91,3.15-3.41,5.23-4.51 c2.08-1.1,4.45-1.85,7.13-2.26C30.63,0.06,33.5,0,36.55,0C37.99,0,55,0,55,0L49.95,12.69z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M88.89,51.02l0.07-28.52L78,51.02H59.8L57.94,0h16.63l-1,31.89L85.74,0h14.76l-0.14,31.96L111.82,0h16.41 l-21.78,51.02H88.89z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "128.11,20.78 122.21,51.02 138.12,51.02 141.63,33.25 157.68,33.25 162.48,20.78  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "165.17,12.69 170.08,0 132.17,0 129.7,12.69  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M159.66,46.65l-0.12,0.58h-1.46v3.8h-0.65v-3.8h-1.54l0.12-0.58H159.66z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M162.04,49.78l-1.16-2.09v3.34h-0.65v-4.38h0.72l1.4,2.51l1.32-2.51h0.73v4.38h-0.65v-3.4l-1.15,2.15H162.04z "
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Hilfslinien",
    className: "st0"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: -17.01,
    y1: 76.54,
    x2: 187.09,
    y2: 76.54
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: -17.01,
    y1: 59.53,
    x2: 187.09,
    y2: 59.53
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: -17.01,
    y1: 51.02,
    x2: 187.09,
    y2: 51.02
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: -17.01,
    y1: 0,
    x2: 187.09,
    y2: 0
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: -17.01,
    y1: 12.69,
    x2: 187.09,
    y2: 12.69
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 170.08,
    y1: 119.06,
    x2: 170.08,
    y2: -17.01
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 164.41,
    y1: 119.06,
    x2: 164.41,
    y2: 36.23
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 155.91,
    y1: 56.69,
    x2: 155.91,
    y2: 42.52
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 0,
    y1: 119.06,
    x2: 0,
    y2: -17.01
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Typo",
    className: "st0"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 14.17,
    cy: 5.67,
    r: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.34,
    y: 4.17,
    className: "st4",
    width: 5.67,
    height: 3
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 13.238 7.1403)",
    className: "st5 st6 st7"
  }, "1"), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 0,
    cy: 59.53,
    r: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    x: -2.83,
    y: 58.03,
    className: "st4",
    width: 5.67,
    height: 3
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 -1.0599 60.9987)",
    className: "st5 st6 st7"
  }, "2"), /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 164.41,
    cy: 42.51,
    r: 2.83
  }), /*#__PURE__*/React.createElement("rect", {
    x: 161.57,
    y: 41.01,
    className: "st4",
    width: 5.67,
    height: 3
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 163.3413 43.9847)",
    className: "st5 st6 st7"
  }, "3"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwf);
export default __webpack_public_path__ + "static/media/swf.06fd49d3c6500df34ddcbb17829cbbc7.svg";
export { ForwardRef as ReactComponent };